import { useContext } from "react";
import { ClientConfigContext } from "../../contexts/ClientConfigContext";

const useClientConfig = () => {
    const context = useContext(ClientConfigContext)

    if (!context) throw new Error('useClientProfile Context must be inside a ClientProfileProvider')

    return context
}

export default useClientConfig;